import React, { useMemo } from "react";
import { BodyMediumText } from "../FormattedText";
import SelectField from "../SelectField";
import { Contract, Repetition, Unit } from "../../__generated__/graphql";
import { useTheme } from "../../hooks/use-theme";
import { useI18n } from "../../hooks/i18n-hooks";
import { MIN_HOURS_PER_WEEK_FULL_TIME, WorkingTimeComponentProps } from "./helpers";
import { useContractCct } from "../../hooks/cct-utils";
import Gap from "../../ui_atoms/Gap";

const HoursPerWeekSection: React.FC<WorkingTimeComponentProps> = ({
    contract,
    setContract,
    disabled,
}) => {
    const { colors, gridSize } = useTheme();
    const i18n = useI18n();
    const currentCCT = useContractCct(contract as Contract);

    const hoursItems = useMemo(() => {
        const hoursPerWeek = currentCCT?.hoursPerWeek || 42;

        const optionsNb = 1 + (hoursPerWeek - MIN_HOURS_PER_WEEK_FULL_TIME) * 2;

        return new Array(optionsNb).fill(0).map((_, index) => {
            const hours = index / 2 + MIN_HOURS_PER_WEEK_FULL_TIME;
            return {
                label: i18n.t("screens.user.create_mission_earning_type.working_percent_format", {
                    hours,
                }),
                value: hours,
            };
        });
    }, [i18n, currentCCT?.hoursPerWeek]);
    return (
        <>
            <BodyMediumText color={colors.body}>
                {i18n.t("screens.user.create_mission_earning_type.hours_per_week")}
            </BodyMediumText>
            <Gap gap="2/3" />
            <SelectField
                asListAction="primary"
                disabled={disabled}
                onSelect={({ value }) => {
                    setContract({
                        ...contract,
                        hoursPerWeekFullTime: value,
                        workingTimeClassicSpec: {
                            unitCount: value,
                            unit: Unit.Hours,
                            repetition: Repetition.Week,
                        },
                    });
                }}
                data={hoursItems}
                value={contract?.hoursPerWeekFullTime || 0}
                right="edit"
                halfScreen
                style={{
                    marginHorizontal: -(gridSize / 2),
                    borderBottomWidth: 0,
                    borderTopWidth: 1,
                }}
                placeholder={i18n.t(
                    "screens.user.create_mission_earning_type.hours_per_week_placeholder",
                )}
            />
        </>
    );
};

export default HoursPerWeekSection;
